const bind = () => {
  (() => {
    const storedTheme = getStoredTheme();
    if (storedTheme) {
      setTheme(storedTheme);
    } else {
      setTheme('auto');
    }
  })();

  if(getStoredTheme() === 'dark'){
    $('#theme-modal .theme-list input[value="dark"]').prop('checked', true);
  } else if(getStoredTheme() === 'light'){
    $('#theme-modal .theme-list input[value="light"]').prop('checked', true);
  } else if(getStoredTheme() === 'high-contrast'){
    $('#theme-modal .theme-list input[value="high-contrast"]').prop('checked', true);
  } else {
    $('#theme-modal .theme-list input[value="auto"]').prop('checked', true);
  }

  $('#theme-modal .theme-list input[type="radio"]').each(function () {
    $(this).on('click', function () {
      setTheme($(this).val());
    })
  })
};

const getStoredTheme = () => localStorage.getItem("theme");
const setStoredTheme = (theme) => localStorage.setItem("theme", theme);

const getPreferredTheme = () => {
  const storedTheme = getStoredTheme();
  if (storedTheme === "dark") {
    return "light";
  } else if (storedTheme === "light") {
    return "dark";
  }

  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
};

const setTheme = (theme) => {
  if (theme === "auto") {
    document.documentElement.setAttribute(
      "data-bs-theme",
      window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light"
    );
    setStoredTheme(theme);
  } else {
    document.documentElement.setAttribute("data-bs-theme", theme);
    setStoredTheme(theme);
  }
};

export { bind };
